import { useChat } from "../../controllers/useChat";
import { ChatView } from "./ChatView";
import type { WorkspaceMember } from "../../models/account";

// Workspace-level chat: any member of the selected workspace can DM or group-chat any other member,
// independent of project membership. Reuses ChatView with a workspace-scoped useChat.
export function WorkspaceChatView({
  workspaceId,
  members,
  currentUserId,
}: {
  workspaceId: string | null;
  members: WorkspaceMember[];
  currentUserId: string | null;
}) {
  const chat = useChat(workspaceId, "workspace", currentUserId);

  if (!workspaceId) {
    return <div className="center">워크스페이스를 먼저 선택하세요</div>;
  }

  return (
    <div className="detail">
      <div style={{ marginBottom: 12 }}>
        <h2 style={{ margin: 0 }}>워크스페이스 채팅</h2>
        <p className="prail-muted" style={{ margin: "4px 0 0" }}>
          워크스페이스 멤버와 1:1 또는 그룹으로 대화하세요.
        </p>
      </div>
      <ChatView chat={chat} members={members} />
    </div>
  );
}
